<template>
	<div class="content">
		<el-image class="logo" :src="businessInfo.image != '' ? businessInfo.image : ''" fit="contain"/>
		<div class="content_info">
			<div class="company_name">{{businessInfo.title != '' ? businessInfo.title : ''}}</div>

            <!-- <el-carousel style="width: 800px;" height="36px" direction="horizontal" autoplay arrow="never" :loop="true" :interval="3000" indicator-position="none">
                <el-carousel-item v-for="(item, index) in orderArr" :key="index">
                  <div style="height: 36px;line-height: 36px;text-align: center;color: red;font-size: 24px;">恭喜 {{item.depart_name}} {{item.admin.nick_name}} 同事 喜开单 {{item.pay_amount}} 元！</div>
                </el-carousel-item>
            </el-carousel> -->

            <Marquee />
              
			<!-- <div class="center">
				<div class="tab_div" :class="tabIndex == index ? 'selectStyle':''" v-for="(item,index) in moduleList"
					:key="index" @click="tabClick(item,index)">
					<div>{{item.name}}</div>
				</div>
			</div> -->
			<div class="right">
				<!-- <el-image class="icon" :src="require('../../assets/delete_icon.png')" />
				<el-image class="icon" :src="require('../../assets/share_icon.png')" /> -->
				<el-image class="icon" :src="require('../../assets/message_icon.png')" style="cursor: pointer;" title="任务进度" @click="showTasks" />

				<div class="userName">
					<el-dropdown @command="handleCommand">
						<span class="el-dropdown-link">
							{{loginInfo.nick_name}}<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="(item,index) in dropdownList"
								:command="item.value">{{item.lable}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
		</div>
		<el-dialog title="修改密码" :visible.sync="dialogStatus" width="500px" :close-on-click-modal="false">
			<el-form :model="pwdForm" status-icon  ref="pwdForm" label-position="top" style="padding: 0 20px;">
				<el-form-item label="旧密码" prop="old_password" :rules="[{ required: true, message: '请填写旧密码', trigger: 'change' }]">
					<el-input :type="!pwdShow?'password':'text'" v-model="pwdForm.old_password" autocomplete="off">
						<el-button slot="append" icon="el-icon-view" @click="pwdShow=!pwdShow"></el-button>
					</el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="new_password" :rules="[{ required: true, message: '请填写新密码', trigger: 'change' }]">
					<el-input :type="!pwdShow1?'password':'text'" v-model="pwdForm.new_password" autocomplete="off">
							<el-button slot="append" icon="el-icon-view" @click="pwdShow1=!pwdShow1"></el-button>
					</el-input>
				</el-form-item>
				<el-form-item style="text-align: right;">
					<el-button @click="$refs['pwdForm'].resetFields()">重置</el-button>
					<el-button type="primary" @click="submitForm()">提交</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

        <el-dialog title="任务进度" :visible.sync="taskVisible" v-if="taskVisible" width="60%">
            <div class="infinite-list-wrapper" >
                <ul class="list" v-infinite-scroll="showTasks" infinite-scroll-disabled="taskdisabled" style="overflow:auto;height: 300px;list-style:none;">
                    <li style="border-top: 1px solid #ccc;border-bottom: 1px solid #ccc;padding: 10px 0;list-style:none;">
                        <span style="display: inline-block;width: 5%;">ID</span>
                        <span style="display: inline-block;width: 15%;">任务</span>
                        <span style="display: inline-block;width: 10%;">状态</span>
                        <span style="display: inline-block;width: 20%;">开始</span>
                        <span style="display: inline-block;width: 20%;">结束</span>
                        <span style="display: inline-block;width: 30%;">操作</span>
                    </li>
                    <li v-for="(item, i) in taskList" :key="i" style="border-bottom: 1px solid #ccc;padding: 10px 0;list-style:none;">
                        <span style="display: inline-block;width: 5%;">{{item.task_id}}</span>
                        <span style="display: inline-block;width: 15%;">{{item.remark}}</span>
                        <span style="display: inline-block;width: 10%;">
                            <el-tag v-if="item.state == 0">{{item.state_text}}</el-tag>
                            <el-tag v-if="item.state == 1" type="warning">{{item.state_text}}</el-tag>
                            <el-tag v-if="item.state == 2" type="primary">{{item.state_text}}</el-tag>
                            <el-tag v-if="item.state == 3" type="danger">{{item.state_text}}</el-tag>
                            <el-tag v-if="item.state == 4" type="info">{{item.state_text}}</el-tag>
                        </span>
                        <span style="display: inline-block;width: 20%;">{{item.created_time}}</span>
                        <span style="display: inline-block;width: 20%;">{{item.state == 4 ? item.updated_time : item.end_time}}</span>
                        <span style="display: inline-block;width: 30%;">
                            <span v-if="item.fail_msg">{{item.fail_msg}}</span>
                            <a v-if="item.file" :href="base.domain + item.file" style="margin: 0 10px;">下载</a>
                            <el-button size="mini" v-if="item.state == 0" @click="handleTaskCancel(item)">取消</el-button>
                        </span>
                    </li>
                </ul>
                <p v-if="taskLoading" style="text-align: center;">加载中...</p>
                <p v-if="taskNomore" style="text-align: center;">没有更多了</p>
            </div>
        </el-dialog>
	</div>
</template>

<script>
    import base from '@/request/base.js'
	import {
		mapMutations,
		mapGetters
	} from 'vuex';
	import {adminChangePassword, crmorderLists, tasks, taskCancel} from '@/request/apis.js'
    import Marquee from "@/components/crm/Marquee.vue"
	export default {
        components: { Marquee },
		props: {
			moduleList: {
				type: Array
			},
		},
		data() {
			return {
                base: base,
				tabIndex: 0,
				routerName: '',
				dropdownList: [
                    // {
					// 	lable: '修改资料',
					// 	value: 1
					// },
					{
						lable: '修改密码',
						value: 2
					},
					{
						lable: '退出',
						value: 3
					}
				],
				companyInfo: {
					company_company: '',
					company_logo: ''
				},
				dialogStatus : false,
				pwdForm: {
					old_password: '',
					new_password: '',
				},
				pwdShow : false,
				pwdShow1 : false,
                // order: {},
                // orderArr: [],
                // timer: null,

                taskVisible: false,
                taskList: [],
                taskLoading: false,
                taskNomore: false,
                taskPage: 1,
			}
		},
		watch: {
			// '$route'(to, from) {
			// 	var index = this.menuInfo.indexOf(to.meta.href)
			// 	this.tabClick(to,index)
			// }
		},
		computed: {
			...mapGetters(['loginInfo']),
			...mapGetters(['businessInfo']),
			...mapGetters(['menuInfo']),
            taskdisabled () {
                return this.taskLoading || this.taskNomore
            },
		},
		mounted() {
			if (localStorage.getItem('tabIndex')) {
				this.$nextTick(() => {
					this.tabIndex = localStorage.getItem('tabIndex');
					this.$emit('itemClick', Number(this.tabIndex));
				})
			}
            // if(this.timer){
            //     clearTimeout(this.timer);
            // }
            // this.getOrder();
		},
		methods: {
			...mapMutations(['clearToken']),

			tabClick(item, index) {
				//判断用户登陆状态
				var loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
				if (loginInfo == null) {
					this.$router.push('/')
				} else {
					localStorage.setItem('tabIndex', index);
					this.tabIndex = localStorage.getItem('tabIndex');
					this.$emit('itemClick', this.tabIndex);
					if (this.routerName != item.path) {
						var path = item.child[0].child.length > 0 ? item.child[0].child[0].path : item.path
						this.$router.push({
							path: path
						}).catch(data => {})
						this.routerName = item.path;
					}
				}
			},

			//用户右上角操作
			handleCommand(command) {
				switch (command) {
					case 1:
						//修改资料
						this.$router.push('/infoUphold');
						break;
					case 2:
						//修改密码
						this.dialogStatus = true;
						break;
					case 3:
						//退出登录
						sessionStorage.clear();
						this.$router.replace('/');
						break;
				}
			},
			//修改密码
			submitForm() {
				this.$refs['pwdForm'].validate((valid) => {
					if (valid) {
						adminChangePassword(this.pwdForm).then(res=>{
							if(!res.code){
								this.dialogStatus = this.pwdShow = this.pwdShow1 = false;
								this.$refs['pwdForm'].resetFields();
								this.$message.success('密码修改成功');
							}else{
								this.$message.error(res.msg);
							}
						})
					}
				});
			},
            async getOrder(){
                var today = new Date();
                var created_date = today.getFullYear() + '-' + ((today.getMonth() + 1).toString().padStart(2, '0')) + '-' + (today.getDate().toString().padStart(2, '0'));
                let res = await crmorderLists({limit: 5, state: [10,30,40,50,60,70], created_date: [created_date, created_date], orderAll: 1, carousel: 1});
                if(res.code === 0){
                    if(res.data.length){
                        this.order = res.data[0];
                        this.orderArr = res.data;
                    }
                }
                if(!this.timer){
                    this.timer = setTimeout(() => {
                        console.log('定时刷新订单列表', new Date());
                        this.getOrder();
                    }, 600000);
                }
            },
            async showTasks(){
                if(this.taskVisible == false){
                    this.taskPage = 1;
                    this.taskList = [];
                }
                this.taskLoading = true;
                this.taskNomore = false;
                const res = await tasks({page: this.taskPage})
                this.taskLoading = false;
                if (res.code) return this.$message.error(res.msg)
                this.taskPage++;
                if(res.data.length < 10){
                    this.taskNomore = true;
                }
                this.taskList = [...this.taskList, ...res.data];
                this.taskVisible = true;
            },
            async handleTaskCancel(row){
                const { data: res } = await taskCancel({task_id: row.task_id})
                if (res.code) return this.$message.error(res.msg)
                row.state_text = '已取消';
                row.state = 4;
                this.$message({ message: res.msg || '取消任务成功', type: 'success'});
            },
		}
	}
</script>

<style scoped>
	.content {
		display: flex;
		flex-direction: row;
		align-items: center;
		background: var(--theme-color2);
		height: 50px
	}

	.logo {
		width: 70px;
		height: 40px;
	}

	.content_info {
		display: flex;
		flex-direction: row;
		width: 100%;
		justify-content: space-between;
		padding: 0 30px 0 11px;
	}

	.company_name {
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #000;
		width: 150px;
		overflow-wrap: break-word;
	}

	.center {
		display: flex;
		flex-direction: row;
		line-height: 66px;
	}

	.tab_div {
		padding: 0 20px;
		font-size: 16px;
		font-weight: bolder;
		margin: 0 5px;
	}

	.selectStyle {
		color: var(--theme-color);
		background: linear-gradient(var(--theme-color) 5%, rgba(255, 255, 255, 0.01) 50%);
	}

	.right {
		display: flex;
		align-items: center;
	}

	.icon {
		width: 15px;
		height: 15px;
		margin: 0 10px;
	}

	.userName {
		font-size: 12px;
		color: #000;
		margin-left: 5px;
        white-space: nowrap;
        flex-shrink: 0;
	}
</style>